// client/src/components/pages/AdminLoginPage.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import './AdminLoginPage.css';

const AdminLoginPage = () => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/admin/login`, {
        username: 'admin',
        password: password,
      });

      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token);
        navigate('/admin/dashboard/quotes');
      }
    } catch (err) {
      setError('Authentication failed. Please verify your administrator password.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-brand">
          <div className="admin-login-logo-ring">
            <img src="/images/makah-medics-logo.jpeg" alt="Makah Medics Logo" />
          </div>
          <span className="admin-portal-badge">
            <i className="fas fa-shield-alt"></i> Secure Management Portal
          </span>
          <h2>Makah Medics Admin</h2>
          <p>Sign in to manage clinical quotes, medical products, and visitor inquiries.</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="login-form-group">
            <label htmlFor="admin-username">Administrator Account</label>
            <div className="login-input-wrapper readonly">
              <i className="fas fa-user-shield input-icon"></i>
              <input
                type="text"
                id="admin-username"
                value="admin"
                readOnly
                tabIndex={-1}
                aria-label="Administrator username"
              />
              <span className="verified-pill">Verified</span>
            </div>
          </div>

          <div className="login-form-group">
            <label htmlFor="password">Access Password</label>
            <div className="login-input-wrapper">
              <i className="fas fa-lock input-icon"></i>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                placeholder="Enter administrator password..."
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoFocus
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
              </button>
            </div>
          </div>

          {error && (
            <div className="admin-login-error" role="alert">
              <i className="fas fa-exclamation-triangle"></i>
              <span>{error}</span>
            </div>
          )}

          <button type="submit" className="btn-login" disabled={isLoading}>
            {isLoading ? (
              <>
                <i className="fas fa-circle-notch fa-spin"></i>
                <span>Authenticating...</span>
              </>
            ) : (
              <>
                <span>Access Dashboard</span>
                <i className="fas fa-arrow-right"></i>
              </>
            )}
          </button>
        </form>

        <div className="admin-login-footer">
          <Link to="/" className="back-to-site-link">
            <i className="fas fa-arrow-left"></i> Return to Public Website
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
